import { render, staticRenderFns } from "./DeveloperTool.vue?vue&type=template&id=4a64cde5"
import script from "./DeveloperTool.vue?vue&type=script&lang=js"
export * from "./DeveloperTool.vue?vue&type=script&lang=js"
import style0 from "./DeveloperTool.vue?vue&type=style&index=0&id=4a64cde5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports